const capabilities = {
    app: ['loader', 'paginator', 'filter', 'sorter', 'exporter', 'error-logger'],
    entity: []
};

export default capabilities;
